import React from 'react';

// status → [label, classes]; buffer_* levels follow Talu's scale (red … green)
const BADGES = {
  done: ['Ziel erreicht ✓', 'border-emerald-500/50 bg-emerald-500/15 text-emerald-300'],
  achieved: ['Erreicht ✓', 'border-emerald-500/50 bg-emerald-500/15 text-emerald-300'],
  ahead: ['Ahead of pace', 'border-emerald-500/40 bg-emerald-500/10 text-emerald-300'],
  behind: ['Behind pace', 'border-red-500/40 bg-red-500/10 text-red-300'],
  missed: ['Verfehlt', 'border-red-500/50 bg-red-500/15 text-red-300'],
  rework: ['Nacharbeit bis So', 'border-amber-500/50 bg-amber-500/15 text-amber-300'],
  no_target: ['Kein Ziel', 'border-border bg-secondary/40 text-muted-foreground'],
  no_data: ['Keine Daten', 'border-border bg-secondary/40 text-muted-foreground'],
  stock_ok: ['Vorrat OK', 'border-emerald-500/40 bg-emerald-500/10 text-emerald-300'],
  stock_low: ['Vorrat niedrig', 'border-red-500/40 bg-red-500/10 text-red-300'],
  buffer_red: ['Kein Puffer', 'border-red-500/50 bg-red-500/15 text-red-300'],
  buffer_orange: ['1–2 Wochen', 'border-orange-500/50 bg-orange-500/15 text-orange-300'],
  buffer_amber: ['3–4 Wochen', 'border-amber-500/50 bg-amber-500/15 text-amber-300'],
  buffer_lime: ['5–6 Wochen', 'border-lime-500/50 bg-lime-500/15 text-lime-300'],
  buffer_teal: ['7–10 Wochen', 'border-teal-500/50 bg-teal-500/15 text-teal-300'],
  buffer_emerald: ['> 10 Wochen', 'border-emerald-500/50 bg-emerald-500/15 text-emerald-300'],
};

export const statusColor = (status) => (['behind', 'missed', 'buffer_red', 'stock_low'].includes(status) ? '#f87171'
  : status === 'rework' ? '#fbbf24' : '#34d399');

export const StatusBadge = ({ status, label, testId }) => {
  const [text, cls] = BADGES[status] || BADGES.no_target;
  return (
    <span className={`self-start shrink-0 text-[9px] font-mono uppercase tracking-wider border rounded-sm px-1.5 py-0.5 ${cls}`} data-testid={testId}>
      {label || text}
    </span>
  );
};
